import React from "react";
import { createRoot } from "react-dom/client";
import "react-datepicker/dist/react-datepicker.css";
import { loadCustomAnalyticsEventHandling } from "@qgiv/p2p-registration";
import { Provider } from "react-redux";
import { /* initSentry, */ loadCss, loadFonts } from "@qgiv/core-js";
import loadIcons from "@qgiv/icons";
import P2PRegistrationApp, { ConnectedInjections } from "./components";
import store from "./redux";
import "./p2pRegistration.scss";
import "./styles/global/_modifiers.scss"; // Modifiers remain last to override any other styles
import ConnectedP2PRegistrationInjection from "./components/ConnectedP2PRegistrationInjection";

const loadCustomCss = () => {
    const state = store.getState();
    const { formSettings } = state;
    const {
        theme: { custom_css = "" },
    } = formSettings;

    loadCss("custom-css", custom_css);
};

// Load custom analytics event handling
loadCustomAnalyticsEventHandling();

// Load Icons into DOM
loadIcons();

// Load custom CSS
loadCustomCss();

// Load fonts
loadFonts();

// Load Sentry performance monitoring
// initSentry({ app: "P2P Registration" }, "react-fundraising-fe");

const appContainer = document.getElementById("app");
const appRoot = createRoot(appContainer);

appRoot.render(<P2PRegistrationApp />);

const injectionsContainer = document.getElementById("injection-container");
const injectionsRoot = createRoot(injectionsContainer);

// Render Injections from Form Injection system (CP)
injectionsRoot.render(
    <Provider store={store}>
        <ConnectedInjections />
    </Provider>,
);
const headerContainer = document.getElementById("cms-injection-container");
const headerRoot = createRoot(headerContainer);

// Render CMS Page Header (gets added to the top of body) Injection

headerRoot.render(
    <Provider store={store}>
        <ConnectedP2PRegistrationInjection dataLocation="header" />
    </Provider>,
);
const footerContainer = document.getElementById(
    "cms-injection-container-footer",
);
const footerRoot = createRoot(footerContainer);

// Render CMS Page Footer Injection
footerRoot.render(
    <Provider store={store}>
        <ConnectedP2PRegistrationInjection dataLocation="footer" />
    </Provider>,
);
